export const INTERFACES_SET_IS_CART_ACTIVE = 'INTERFACES_SET_IS_CART_ACTIVE';
export const INTERFACES_SET_PETITE_DROPDOWN_STATE = 'INTERFACES_SET_PETITE_DROPDOWN_STATE';
export const INTERFACES_TOGGLE_GLOBAL_SEARCH_VISIBILITY = 'INTERFACES_TOGGLE_GLOBAL_SEARCH_VISIBILITY';
export const INTERFACES_SET_IS_NAVIGATION_ACTIVE = 'INTERFACES_SET_IS_NAVIGATION_ACTIVE';
export const INTERFACES_SET_IS_SORT_ACTIVE = 'INTERFACES_SET_IS_SORT_ACTIVE';
export const INTERFACES_TOGGLE_IS_LOADING = 'INTERFACES_TOGGLE_IS_LOADING';
export const INTERFACES_SET_PAGE_TYPE = 'INTERFACES_SET_PAGE_TYPE';
export const INTERFACES_KUSTOMER_CHATBOT_LOADED = 'INTERFACES_KUSTOMER_CHATBOT_LOADED';
export const INTERFACES_KUSTOMER_CHATBOT_STARTED = 'INTERFACES_KUSTOMER_CHATBOT_STARTED';
